export const MessageFifth = ({
  width = '16',
  height = '16',
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_188_683)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6 0H14.4C15.2824 0 16 0.7176 16 1.6V11.2C16 12.0824 15.2824 12.8 14.4 12.8H4.2664L0 16V1.6C0 0.7176 0.7176 0 1.6 0ZM3.7336 11.2H14.4V1.6H1.6V12.8L3.7336 11.2ZM12 4H4V5.6H12V4ZM9.6 7.2H4V8.8H9.6V7.2Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_188_683">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
